// import React, { ChangeEvent, useRef, useState } from 'react';
//
// import { useUploadFiles } from '@features/ModalFilesUploader/lib/hooks/useUploadFile';
// import { generateId, processFile } from '@shared/helpers';
//
// interface IUseDnd<T> {
//     isDisabled: boolean;
//     attachmentsData: T;
//     setAttachmentsData: (attachments: T) => void;
// }
//
// export const useDnd = <T extends { id: string }[]>({
//     attachmentsData,
//     setAttachmentsData,
//     isDisabled,
// }: IUseDnd<T>) => {
//     const [isFileOver, setIsFileOver] = useState(false);
//     // const [attachments, setAttachments] = useState(attachmentsData);
//     const fileInputRef = useRef<HTMLInputElement>(null);
//
//     const onAddFiles = async (files: File[]) => {
//         const tempAttachments = files.map((file) => ({
//             file,
//             isLoading: true,
//             id: generateId(),
//         })) as unknown as T[];
//
//         // setAttachments((prev) => [...prev, ...tempAttachments]);
//         setAttachmentsData([...attachmentsData, ...tempAttachments]);
//
//         const processedFiles = await Promise.all(
//             files.map((file) => {
//                 const temp = tempAttachments.find((ta) => ta?.file.name === file.name);
//                 const fileId = temp ? temp.id : generateId();
//                 return processFile(file, fileId);
//             })
//         );
//
//         // setAttachments((prev) =>
//         //     prev.map(
//         //         (attachment) => processedFiles.find((pf) => pf.id === attachment.id) || attachment
//         //     )
//         // );
//
//         const updated: T[] = attachmentsData.map((attachment) => {
//             const matched = processedFiles.find((pf) => (pf as T).id === (attachment as any).id);
//             return (matched as T) || attachment;
//         });
//
//         setAttachmentsData(updated);
//     };
//     // const uploadFilesHandler = useUploadFiles(onAddFiles, attachments.length || 0);
//     const uploadFilesHandler = useUploadFiles(onAddFiles, attachmentsData.length || 0);
//     const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
//         e.preventDefault();
//         e.stopPropagation();
//
//         if (isDisabled) return;
//
//         setIsFileOver(false);
//         const uploadFiles = Array.from(e.dataTransfer.files);
//
//         uploadFilesHandler(uploadFiles);
//     };
//
//     const handleDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
//         e.preventDefault();
//         if (isDisabled) return;
//
//         setIsFileOver(true);
//     };
//     const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
//         e.preventDefault();
//         if (isDisabled) return;
//
//         if (attachmentsData.length > 0) return;
//         // if (attachments.length > 0) return;
//         setIsFileOver(true);
//     };
//
//     const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
//         e.preventDefault();
//         const { relatedTarget } = e;
//
//         if (!e.currentTarget.contains(relatedTarget as Node)) {
//             setIsFileOver(false);
//         }
//     };
//
//     const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
//         e.preventDefault();
//         e.stopPropagation();
//         if (isDisabled) return;
//
//         const uploadFiles = Array.from(e.target.files);
//
//         uploadFilesHandler(uploadFiles);
//         e.target.value = '';
//     };
//
//     const clickFileInput = () => {
//         fileInputRef.current?.click();
//     };
//
//     const handleDnDClick = () => {
//         // if (isDisabled || attachments.length > 0) return;
//         if (isDisabled || attachmentsData.length > 0) return;
//         clickFileInput();
//     };
//
//     return {
//         handleDragLeave,
//         handleDragEnter,
//         handleDragOver,
//         handleDrop,
//         handleDnDClick,
//         handleInputChange,
//         clickFileInput,
//         isFileOver,
//         attachments: attachmentsData,
//         fileInputRef,
//     };
// };

import React, { ChangeEvent, useState } from 'react';

interface IUseDnd<T> {
    isDisabled: boolean;
    attachmentsData: T[];
    onUploadHandler: (files: File[]) => void;
    fileInputRef: React.RefObject<HTMLInputElement>;
}

export const useDnd = <T>({
    attachmentsData,
    isDisabled,
    onUploadHandler,
    fileInputRef,
}: IUseDnd<T>) => {
    const [isFileOver, setIsFileOver] = useState(false);

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (isDisabled) return;
        setIsFileOver(false);

        const files = Array.from(e.dataTransfer.files);
        onUploadHandler(files);
    };

    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (isDisabled) return;

        const files = Array.from(e.target.files || []);
        onUploadHandler(files);
        e.target.value = '';
    };

    const clickFileInput = () => {
        fileInputRef.current?.click();
    };

    const handleDnDClick = () => {
        if (isDisabled || (attachmentsData as unknown[]).length > 0) return;
        clickFileInput();
    };

    return {
        handleDragLeave: (e: React.DragEvent<HTMLDivElement>) => {
            e.preventDefault();
            const { relatedTarget } = e;
            if (!e.currentTarget.contains(relatedTarget as Node)) {
                setIsFileOver(false);
            }
        },
        handleDragEnter: (e: React.DragEvent<HTMLDivElement>) => {
            e.preventDefault();
            if (!isDisabled) setIsFileOver(true);
        },
        handleDragOver: (e: React.DragEvent<HTMLDivElement>) => {
            e.preventDefault();
            if (!isDisabled && (attachmentsData as unknown[]).length === 0) {
                setIsFileOver(true);
            }
        },
        handleDrop,
        handleInputChange,
        handleDnDClick,
        clickFileInput,
        fileInputRef,
        isFileOver,
        attachments: attachmentsData,
    };
};
